import Vue from 'vue'
import Router from 'vue-router'
// Vue Meta - Meta tags Plugin
import Meta from 'vue-meta'

// Components
import HomePage from '@/components/HomePage/HomePage.vue'
import CasesList from '@/components/CasesList/CasesList.vue'
import CaseComponent from '@/components/CaseComponent/CaseComponent.vue'
// import KitchenCase from '@/components/KitchenCase/KitchenCase.vue'
import ProcessPage from '@/components/ProcessPage/ProcessPage.vue'
import AerospaceCase from '@/components/AerospaceCase/AerospaceCase.vue'
import ItemPage from '@/components/ItemPage/ItemPage.vue'
import NotFound from '@/components/NotFound/NotFound.vue'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
  scrollBehavior () {
    return {x: 0, y: 0}
  },
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: HomePage,
      meta: {
        title: 'Home | TMG.io'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        title: 'Contact | TMG.io'
      }
    },
    {
      path: '/case',
      component: CasesList,
      meta: {
        title: 'Work | TMG.io'
      }
    },
    {
      path: '/boeing',
      component: CaseComponent,
      meta: {
        title: 'Boeing | TMG.io'
      }
    },
    // page waiting for confirmation
    // {
    //   path: '/major-appliance-retailer',
    //   component: KitchenCase
    // },
    {
      path: '/aerospace',
      component: AerospaceCase,
      meta: {
        title: 'Aerospace | TMG.io'
      }
    },
    {
      path: '/process',
      component: ProcessPage,
      meta: {
        title: 'Process | TMG.io'
      }
    },
    // {
    //   path: '/yeti',
    //   component: ItemPage,
    //   name: 'yeti',
    //   meta: {
    //     title: 'Yeti | TMG.io'
    //   }
    // },
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: {
        title: '404 | TMG.io'
      }
    }, {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js